/**
 * Path segments for lumopages.com legal & help URLs.
 * Source of truth: lumopages.com/src/lib/legal-pages.ts (keep slugs in sync).
 */

import { MAIN_URL } from "./consts";

export const LEGAL_PAGE_SLUGS = {
  privacyPolicy: "privacy-policy",
  termsOfUse: "terms-of-use",
  refundPolicy: "refund-policy",
  accessibilityStatement: "accessibility-statement",
  dataProcessingAgreement: "data-processing-agreement",
  subProcessorAppendix: "sub-processor-appendix",
  userCreatedPagesTerms: "user-created-pages-terms",
  userCreatedPagesPrivacy: "user-created-pages-privacy",
  userCreatedPagesAccessibility: "user-created-pages-accessibility",
  helpCenter: "help",
};

export function legalPageUrl(key) {
  const base = MAIN_URL.endsWith("/") ? MAIN_URL : `${MAIN_URL}/`;
  return `${base}${LEGAL_PAGE_SLUGS[key]}/`;
}
